// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class LongDocumentDocumentCreateModelResponse {
    static getAttributeTypeMap() {
        return LongDocumentDocumentCreateModelResponse.attributeTypeMap;
    }
}
LongDocumentDocumentCreateModelResponse.discriminator = undefined;
LongDocumentDocumentCreateModelResponse.additionalProperties = false;
LongDocumentDocumentCreateModelResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "number"
    },
    {
        "name": "additionalData",
        "baseName": "additionalData",
        "type": "DocumentCreateResponseModel"
    },
];
//# sourceMappingURL=longDocumentDocumentCreateModelResponse.js.map